import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=2f5df1db&"
import script from "./popover.vue?vue&type=script&lang=js&"
export * from "./popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5df1db')) {
      api.createRecord('2f5df1db', component.options)
    } else {
      api.reload('2f5df1db', component.options)
    }
    module.hot.accept("./popover.vue?vue&type=template&id=2f5df1db&", function () {
      api.rerender('2f5df1db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popover/popover.vue"
export default component.exports